import { render, staticRenderFns } from "./ReviewDetails.vue?vue&type=template&id=132fd010&scoped=true"
import script from "./ReviewDetails.vue?vue&type=script&lang=js"
export * from "./ReviewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132fd010",
  null
  
)

export default component.exports